import React, { useEffect ,useState ,useContext } from 'react'
import { database } from '../firebase'

export function useBoltData() {
    return useContext(TutorBoltDataContext)
}

const TutorBoltDataContext = React.createContext()
export default function TutoBoltDataProvider({ children }) {

    const [subjectList, setSubjectList] = useState({})
    const [locationList, setLocationList] = useState({})
    const [courseTypeList, setCourseTypeList] = useState({})
    useEffect(() => {
        return database.doc_data_subjects.get().then((doc) => {
            if (doc.exists) {
                //console.log("fetched subjects");
                setSubjectList(database.formattedDoc(doc).list)
            } else {
                // doc.data() will be undefined in this case
               // console.log("No such document!");
            }
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
    }, [])
    useEffect(() => {
        return database.doc_data_locations.get().then((doc) => {
            if (doc.exists) {
                //console.log("fetched locations");

                setLocationList(database.formattedDoc(doc).list)
            } else {
                // doc.data() will be undefined in this case
                console.log("No such document!");
            }
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
    }, [])
    useEffect(() => {
        return database.doc_data_courseTypes.get().then((doc) => {
            if (doc.exists) {
                //console.log("fetched locations");

                setCourseTypeList(database.formattedDoc(doc).list)
            } else {
                // doc.data() will be undefined in this case
                console.log("No such document!");
            }
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
    }, [])

    const value = {
        subjectList,
        locationList,
        courseTypeList
    }
    return (
        <TutorBoltDataContext.Provider value={value}>
            {children}
        </TutorBoltDataContext.Provider>
    )
}
